import { BigNum, PerpMarketAccount, PositionDirection } from '@drift-labs/sdk';
import { ENUM_UTILS, MarketId } from '@drift/common';
import { SlippageTolerance } from '../@types/types';
import {
	ADDITIONAL_AUCTION_BUFFERS,
	SLIPPAGE_PRESETS_MAJORS,
	SLIPPAGE_PRESETS_NON_MAJORS,
} from 'src/constants/constants';
import { isMajorMarket } from './market';

export const isForceAuctionEndPriceUpToSlippage = (
	slippageTolerance: SlippageTolerance,
	marketId: MarketId
) => {
	return (
		!isMajorMarket(marketId) || isCustomSlippage(slippageTolerance, marketId)
	);
};

const isCustomSlippage = (
	slippageTolerance: SlippageTolerance,
	marketId: MarketId
) => {
	return (
		slippageTolerance !== 'dynamic' &&
		(isMajorMarket(marketId)
			? !SLIPPAGE_PRESETS_MAJORS.includes(slippageTolerance)
			: !SLIPPAGE_PRESETS_NON_MAJORS.includes(slippageTolerance))
	);
};

export const getAdditionalEndPriceBuffer = (
	perpMarketAccount: PerpMarketAccount | undefined
) => {
	if (!perpMarketAccount || !perpMarketAccount.amm) return undefined;

	const tickMultiplier = ADDITIONAL_AUCTION_BUFFERS.find(
		(item) => item.marketIndex === perpMarketAccount.marketIndex
	)?.ticks;

	if (!tickMultiplier) return undefined;

	return tickMultiplier.mul(perpMarketAccount.amm.orderTickSize);
};

export const getTriggerLimitBufferPrice = (
	triggerPrice: BigNum,
	triggerOrderDirection: PositionDirection,
	bufferPercent = 1 // default to 1%
): BigNum => {
	const bufferPercentDecimal = bufferPercent / 100;

	const bufferLimitPrice = ENUM_UTILS.match(
		triggerOrderDirection,
		PositionDirection.LONG
	)
		? triggerPrice.scale(10_000 * (1 + bufferPercentDecimal), 10_000)
		: triggerPrice.scale(10_000 * (1 - bufferPercentDecimal), 10_000);

	return bufferLimitPrice;
};
